// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__V6UU7","col":"styles_col__2EUu8"};